function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["styles", "controlData"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import { WFSLayer } from '../../mapwfs2/domain/WFSLayer';
import { VectorStyle } from '../../mapmodule/domain/VectorStyle';
import { DESCRIBE_LAYER } from '../../mapmodule/domain/constants';
export var UserDataLayer = /*#__PURE__*/function (_WFSLayer) {
  function UserDataLayer() {
    var _this;
    _classCallCheck(this, UserDataLayer);
    _this = _callSuper(this, UserDataLayer, arguments);
    _this._locale = {};
    _this.__internalFlagForUsersOwnLayers = false;
    _this._describeLayerStatus = DESCRIBE_LAYER.PREDEFINED;
    return _this;
  }
  _inherits(UserDataLayer, _WFSLayer);
  return _createClass(UserDataLayer, [{
    key: "isFilterSupported",
    value: function isFilterSupported() {
      return false;
    }
  }, {
    key: "getName",
    value: function getName(lang) {
      return this.getValueFromLocale('name', lang);
    }
  }, {
    key: "getLocale",
    value: function getLocale() {
      return this._locale;
    }
  }, {
    key: "setLocale",
    value: function setLocale() {
      var locale = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this._locale = locale;
    }
  }, {
    key: "getLocaleValues",
    value: function getLocaleValues() {
      var values = Oskari.getLocalized(this._locale) || {};
      return Object.keys(values).reduce(function (sanitized, key) {
        sanitized[key] = Oskari.util.sanitize(values[key]);
        return sanitized;
      }, {});
    }
  }, {
    key: "getValueFromLocale",
    value: function getValueFromLocale(key) {
      var _this$_locale$lang;
      var lang = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Oskari.getLang();
      var value = (_this$_locale$lang = this._locale[lang]) === null || _this$_locale$lang === void 0 ? void 0 : _this$_locale$lang[key];
      if (!value || !value.trim().length) {
        var _this$_locale$Oskari$;
        value = ((_this$_locale$Oskari$ = this._locale[Oskari.getDefaultLanguage()]) === null || _this$_locale$Oskari$ === void 0 ? void 0 : _this$_locale$Oskari$[key]) || '';
      }
      return Oskari.util.sanitize(value);
    }
  }, {
    key: "handleUpdatedLayer",
    value: function handleUpdatedLayer(_ref) {
      var locale = _ref.locale,
        describeLayer = _ref.describeLayer;
      this.setLocale(locale);
      // to be sure that layer is updated properly
      this.preHandleDescribeLayer(describeLayer);
      // update current style (has only 'default' style)
      this.selectStyle();
    }
  }, {
    key: "preHandleDescribeLayer",
    value: function preHandleDescribeLayer() {
      var describeLayer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // Only styles and controlData are needed from DescribeLayer here
      // others will be handled on add maplayer
      var _describeLayer$styles = describeLayer.styles,
        styles = _describeLayer$styles === void 0 ? [] : _describeLayer$styles,
        _describeLayer$contro = describeLayer.controlData,
        controlData = _describeLayer$contro === void 0 ? {} : _describeLayer$contro,
        toStore = _objectWithoutProperties(describeLayer, _excluded);
      this._controlData = controlData;
      this.setStyles(styles.map(function (s) {
        return new VectorStyle(s);
      }));
      if (this.getDescribeLayerStatus() !== DESCRIBE_LAYER.LOADED) {
        // describe layer isn't processed, update predifened info
        this.setDescribeLayerInfo(toStore);
      }
    }

    /**
     * Internal information as link params might produce layers that are NOT this user's layers in the maplayerservice
     */
  }, {
    key: "markAsInternalDownloadSource",
    value: function markAsInternalDownloadSource() {
      this.__internalFlagForUsersOwnLayers = true;
    }
  }, {
    key: "isInternalDownloadSource",
    value: function isInternalDownloadSource() {
      return this.__internalFlagForUsersOwnLayers;
    }
  }]);
}(WFSLayer);